// extracted by mini-css-extract-plugin
module.exports = {"minHeight":"styles_minHeight__1ZEmQ","placeholderAnchor":"styles_placeholderAnchor__3HNWP","placeholder":"styles_placeholder__1n0vL","spaceUnder":"styles_spaceUnder__2pN0Y"};